/* Al Hayat theme layer. Vanilla, no dependencies. Works with Dawn's cart drawer. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const small = matchMedia('(max-width: 860px)');
  const fmt = (cents) => {
    const f = 'AED {{amount_no_decimals}}';
    const n = cents / 100;
    const two = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const none = Math.round(n).toLocaleString('en-US');
    return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, none).replace(/\{\{\s*amount\s*\}\}/, two).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, two.replace('.', ','));
  };

  /* ---------- Engine (homepage only) ---------- */
  if (window.ScrollCraft) window.ScrollCraft.mount(document.body);

  /* ---------- Cart: add through Dawn's drawer ---------- */
  async function ahAdd(items, trigger) {
    const drawer = document.querySelector('cart-drawer');
    const body = { items };
    if (drawer) { body.sections = drawer.getSectionsToRender().map((s) => s.id); body.sections_url = location.pathname; }
    const label = trigger && (trigger.querySelector('span') || trigger), was = label ? label.textContent : '';
    if (trigger) { trigger.classList.add('is-loading'); if (label && !trigger.classList.contains('ah-mini')) label.textContent = 'Adding…'; }
    document.dispatchEvent(new CustomEvent('ah:adding', { detail: { trigger } }));
    let ok = false;
    try {
      const res = await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body),
      });
      const state = await res.json();
      if (state.status) throw new Error(state.description || state.message || 'Could not add to cart.');
      if (drawer) {
        if (!state.id && state.items) state.id = state.items[0].id;
        drawer.classList.contains('is-empty') && drawer.classList.remove('is-empty');
        await new Promise((r) => setTimeout(r, reduce ? 0 : 520));
        drawer.renderContents(state);
      } else location.href = '/cart';
      document.dispatchEvent(new CustomEvent('ah:cart', { detail: state }));
      ok = true;
      return true;
    } catch (e) {
      throw e;
    } finally {
      if (trigger) {
        trigger.classList.remove('is-loading');
        if (ok) { trigger.classList.add('is-added'); if (label && !trigger.classList.contains('ah-mini')) label.textContent = 'Added'; }
        setTimeout(() => { trigger.classList.remove('is-added'); if (label && !trigger.classList.contains('ah-mini')) label.textContent = was; }, 1800);
      }
    }
  }
  window.ahAdd = ahAdd;
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-ah-add]');
    if (!b) return;
    e.preventDefault();
    ahAdd([{ id: +b.dataset.ahAdd, quantity: 1 }], b).catch((err) => alertInline(b, err.message));
  });
  function alertInline(el, msg) {
    let p = el.parentElement.querySelector('.ah-err');
    if (!p) { p = document.createElement('p'); p.className = 'ah-err'; p.setAttribute('role', 'alert'); el.parentElement.append(p); }
    p.hidden = false; p.textContent = msg;
  }

  /* ---------- Header: overlay, search, mobile menu ---------- */
  const bar = $('#ah-bar');
  if (bar && bar.dataset.overlay === 'true') {
    const hero = $('.ah-hero');
    const on = () => bar.classList.toggle('is-over', !!hero && hero.getBoundingClientRect().bottom > 120);
    addEventListener('scroll', on, { passive: true }); on();
  }
  const waf = $('#ah-wa-float');
  if (waf && !waf.classList.contains('is-on')) { const t = () => waf.classList.toggle('is-on', scrollY > innerHeight * 0.5); addEventListener('scroll', t, { passive: true }); t(); }
  const scrim = $('#ah-scrim');
  let openEl = null, lastFocus = null;
  const open = (el, focus) => {
    close(); lastFocus = document.activeElement; openEl = el;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); scrim && scrim.classList.add('is-open');
    setTimeout(() => (focus ? $(focus) : el.querySelector('a, button, input'))?.focus(), 60);
  };
  function close() {
    if (!openEl) return;
    openEl.classList.remove('is-open'); openEl.setAttribute('aria-hidden', 'true'); scrim && scrim.classList.remove('is-open');
    if (openEl.id === 'ah-mnav') $('#ah-menu-btn')?.setAttribute('aria-expanded', 'false');
    openEl = null; lastFocus?.focus?.();
  }
  scrim?.addEventListener('click', close);
  addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  $('#ah-search-btn')?.addEventListener('click', () => open($('#ah-search'), '#ah-q'));
  $('#ah-search-close')?.addEventListener('click', close);
  $('#ah-menu-btn')?.addEventListener('click', () => { open($('#ah-mnav'), '#ah-mnav-close'); $('#ah-menu-btn').setAttribute('aria-expanded', 'true'); });
  $('#ah-mnav-close')?.addEventListener('click', close);

  const q = $('#ah-q'), results = $('#ah-results');
  if (q && results) {
    let t, ctrl;
    q.addEventListener('input', () => {
      clearTimeout(t);
      t = setTimeout(async () => {
        const term = q.value.trim();
        if (term.length < 2) { results.innerHTML = ''; return; }
        ctrl?.abort(); ctrl = new AbortController();
        try {
          const r = await fetch(`/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=8`, { signal: ctrl.signal });
          const j = await r.json();
          const items = j.resources?.results?.products || [];
          results.innerHTML = items.length
            ? items.map((p) => `<a href="${p.url}">${p.image ? `<img src="${p.image}&width=400" alt="" loading="lazy">` : ''}<span>${p.title}</span><span class="ah-price">${p.price ? fmt(Math.round(parseFloat(p.price) * 100)) : ''}</span></a>`).join('')
            : `<p>No products match “${term.replace(/[<>&]/g, '')}”. Try sofa, bed, oak or table.</p>`;
        } catch (_) { /* aborted */ }
      }, 180);
    });
  }

  /* ---------- Hero: KIE ambient loop over the still ---------- */
  const vid = $('#ah-hero-video');
  if (vid && !reduce) {
    const src = small.matches ? (vid.dataset.srcMobile || vid.dataset.src) : (vid.dataset.src || vid.dataset.srcMobile);
    if (src) {
      vid.src = src;
      vid.addEventListener('playing', () => vid.classList.add('is-playing'), { once: true });
      new IntersectionObserver(([e]) => (e.isIntersecting ? vid.play().catch(() => {}) : vid.pause())).observe(vid);
    }
  }

  /* ---------- Chips + collection filters ---------- */
  function wireFilters(grid, opts = {}) {
    if (!grid) return;
    const cards = $$('.ah-card:not(.ah-feature)', grid);
    const tile = $('[data-tile]', grid);
    const st = { k: 'all', wall: null, sale: false, max: Infinity, sort: 'feat' };
    const apply = () => {
      let n = 0;
      cards.forEach((c) => {
        const w = +c.dataset.w || null, p = +c.dataset.p;
        const ok = (st.k === 'all' || c.dataset.k === st.k) && (!st.sale || c.dataset.sale === '1') && p <= st.max && (!st.wall || (w && w + 20 <= st.wall));
        c.classList.toggle('is-out', !ok); if (ok) n++;
      });
      const feat = $('.ah-feature', grid);
      if (feat) feat.hidden = st.k !== 'all';
      if (opts.sortable) {
        const key = { feat: (c) => +c.dataset.i, pa: (c) => +c.dataset.p, pd: (c) => -c.dataset.p, wa: (c) => +c.dataset.w || 1e6, wd: (c) => -(+c.dataset.w || 0) }[st.sort];
        let vis = 0; [...cards].sort((a, b) => key(a) - key(b)).forEach((c) => { grid.append(c); if (!c.classList.contains('is-out') && ++vis === 6 && tile) grid.append(tile); });
      }
      if (opts.count) opts.count.textContent = `${n} ${n === 1 ? 'piece' : 'pieces'}${st.wall ? ` fit a ${st.wall} cm wall` : ''}`;
      if (opts.empty) opts.empty.hidden = n > 0;
      if (tile) tile.hidden = n === 0;
      $('.ah-fitwall')?.classList.toggle('is-on', !!st.wall);
    };
    return { st, apply, cards };
  }

  $$('[data-ah-chips]').forEach((wrap) => {
    const f = wireFilters(document.getElementById(wrap.dataset.ahChips));
    if (!f) return;
    $$('.ah-chip', wrap).forEach((b) => {
      if (b.dataset.k !== 'all' && !f.cards.some((c) => c.dataset.k === b.dataset.k)) b.hidden = true;
      b.addEventListener('click', () => { $$('.ah-chip', wrap).forEach((x) => x.setAttribute('aria-pressed', x === b)); f.st.k = b.dataset.k; f.apply(); });
    });
  });

  /* Collection filtering lives in ah-v2.js. */

  /* ---------- The tape ---------- */
  const fitData = $('#ah-fit-data');
  if (fitData) {
    const D = JSON.parse(fitData.textContent);
    const pieces = D.pieces.map((p, i) => ({ ...p, key: 'p' + i }));
    const mains = pieces.filter((p) => p.role === 'main').sort((a, b) => b.w - a.w);
    const sides = pieces.filter((p) => p.role === 'side');
    const chairs = pieces.filter((p) => p.role === 'chair');
    const GAP = D.gap, CLEAR = D.clear, MAX = D.max;
    // Every sensible arrangement from the pieces given, widest first.
    const sets = [];
    const s0 = sides[0], c0 = chairs[0];
    mains.forEach((m) => {
      if (s0 && c0) sets.push([s0, m, s0, c0]);
      if (s0) sets.push([s0, m, s0], [m, s0]);
      sets.push([m]);
    });
    chairs.forEach((c) => { if (s0) sets.push([c, s0, c], [c, s0]); sets.push([c]); });
    if (s0) sets.push([s0]);
    const width = (ids) => ids.reduce((s, p) => s + p.w, 0) + GAP * (ids.length - 1);
    sets.sort((a, b) => width(b) - width(a));

    const box = $('#ah-stagebox'), wall = $('#ah-wall'), range = $('#ah-wall-range'), num = $('#ah-wall-cm');
    const pool = {};
    pieces.forEach((p) => {
      pool[p.key] = [0, 1].map(() => {
        const d = document.createElement('div'); d.className = 'ah-piece is-out';
        // Two silhouette copies of the cut-out make the shadows: a soft one cast on the wall, a tight one under the feet.
        d.innerHTML = `<img class="ah-piece__cast" src="${p.img}" alt="" draggable="false"><img src="${p.img}" alt="" draggable="false"><img class="ah-piece__foot" src="${p.img}" alt="" draggable="false"><span class="ah-w">${p.w} cm</span>`;
        wall.append(d); return d;
      });
    });
    let W = D.start, scale = 2;
    const layout = () => {
      const cw = box.clientWidth; scale = cw / MAX;
      box.style.setProperty('--rw', cw + 'px');
      box.style.setProperty('--t10', 10 * scale + 'px');
      box.style.setProperty('--t50', 50 * scale + 'px');
      box.style.setProperty('--wh', Math.max(150, 120 * scale) + 'px');
      const ruler = $('#ah-ruler'); $$('.ah-num', ruler).forEach((n) => n.remove());
      const step = cw < 600 ? 100 : 50;
      for (let c = step; c < MAX; c += step) { const s = document.createElement('span'); s.className = 'ah-num'; s.style.left = c * scale + 'px'; s.textContent = c; ruler.append(s); }
      draw();
    };
    let current = [];
    function draw() {
      box.style.setProperty('--tw', W * scale + 'px');
      $('#ah-hook-val').textContent = W + ' cm';
      range.value = W; range.setAttribute('aria-valuetext', W + ' centimetres');
      if (document.activeElement !== num) num.value = W;
      const set = sets.find((s) => width(s) + CLEAR * 2 <= W);
      Object.values(pool).flat().forEach((d) => d.classList.add('is-out'));
      const list = $('#ah-fit-list'); list.innerHTML = '';
      let total = 0;
      current = set || [];
      if (set) {
        let x = (W - width(set)) / 2; const used = {};
        set.forEach((p) => {
          const i = (used[p.key] = (used[p.key] ?? -1) + 1), d = pool[p.key][i];
          d.style.width = p.w * scale + 'px'; d.style.setProperty('--x', x * scale + 'px'); d.classList.remove('is-out');
          x += p.w + GAP; total += p.p;
        });
        const counts = new Map(); set.forEach((p) => counts.set(p, (counts.get(p) || 0) + 1));
        counts.forEach((n, p) => { const li = document.createElement('li'); li.innerHTML = `<img src="${p.img}" alt=""><b>${n > 1 ? n + ' × ' : ''}${p.t}</b><span>${p.w} cm · ${fmt(p.p * n)}</span>`; list.append(li); });
        const spare = W - width(set), main = set.find((p) => p.role === 'main');
        $('#ah-verdict').textContent = main
          ? (set.length === 1 ? `A ${W} cm wall takes the ${main.t}, with ${spare} cm to spare.` : `A ${W} cm wall takes the ${main.t} and ${set.length - 1} more piece${set.length > 2 ? 's' : ''}, with ${spare} cm to spare.`)
          : `A ${W} cm wall is too narrow for a sofa, so the tape sets a reading corner with ${spare} cm to spare.`;
        $('#ah-fit-add').disabled = !set.every((p) => p.ok);
      } else {
        $('#ah-verdict').textContent = 'That wall is narrower than the smallest piece plus walking room.';
        $('#ah-fit-add').disabled = true;
      }
      $('#ah-fit-total').textContent = fmt(total);
    }
    const setW = (v) => { W = Math.max(60, Math.min(MAX, Math.round(v / 5) * 5 || 60)); draw(); };
    range.addEventListener('input', () => setW(+range.value));
    num.addEventListener('change', () => setW(+num.value));
    num.addEventListener('keydown', (e) => { if (e.key === 'Enter') setW(+num.value); });
    $('#ah-fit-add').addEventListener('click', (e) => {
      const m = new Map(); current.forEach((p) => m.set(p.id, (m.get(p.id) || 0) + 1));
      ahAdd([...m].map(([id, quantity]) => ({ id, quantity })), e.currentTarget).catch((err) => alertInline(e.currentTarget, err.message));
    });
    new ResizeObserver(layout).observe(box);
    layout();

    // Scroll draws the tape out while the section is pinned; touching it hands control over.
    const sec = $('#fit'); let touched = false, lastP = -1;
    ['pointerdown', 'keydown'].forEach((ev) => range.addEventListener(ev, () => (touched = true)));
    num.addEventListener('input', () => (touched = true));
    if (!reduce) {
      const smallMain = mains.length ? mains[mains.length - 1].w + CLEAR * 2 + 10 : Math.min(...pieces.map((p) => p.w)) + 40;
      const lo = Math.max(120, smallMain), hi = Math.min(MAX - 40, Math.max(lo + 120, D.start + 60));
      setW(lo);
      const tick = () => {
        if (!touched) {
          const p = parseFloat(getComputedStyle(sec).getPropertyValue('--sc-p')) || 0;
          if (Math.abs(p - lastP) > 0.002) { lastP = p; const k = Math.min(1, Math.max(0, (p - 0.08) / 0.7)); setW(lo + (hi - lo) * (k * k * (3 - 2 * k))); }
        }
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }
  }

  /* ---------- Finishes ---------- */
  const sws = $$('.ah-sw');
  if (sws.length) {
    const sec = sws[0].closest('.ah-finish'), imgs = $$('.ah-plinth img', sec);
    sws.forEach((sw) => sw.addEventListener('click', () => {
      if (sw.getAttribute('aria-checked') === 'true') return;
      sws.forEach((x) => x.setAttribute('aria-checked', x === sw));
      const cur = imgs.find((i) => i.classList.contains('is-on')), nxt = imgs.find((i) => i.dataset.fin === sw.dataset.fin);
      imgs.forEach((i) => i.classList.remove('is-leaving'));
      if (cur) { cur.classList.replace('is-on', 'is-leaving'); setTimeout(() => cur.classList.remove('is-leaving'), 760); }
      nxt?.classList.add('is-on');
      sec.style.setProperty('--fin', sw.dataset.tint);
      const pr = $('.ah-buyrow .ah-price', sec); if (pr) pr.innerHTML = sw.dataset.price + (sw.dataset.was ? `<s>${sw.dataset.was}</s>` : '');
      const add = $('#ah-fin-add'); if (add) add.dataset.ahAdd = sw.dataset.id;
      const link = $('#ah-fin-link'); if (link) link.href = sw.dataset.url;
    }));
    $('.ah-swatches')?.addEventListener('keydown', (e) => {
      if (!['ArrowRight', 'ArrowLeft'].includes(e.key)) return;
      const i = sws.findIndex((x) => x.getAttribute('aria-checked') === 'true');
      const n = sws[(i + (e.key === 'ArrowRight' ? 1 : sws.length - 1)) % sws.length]; n.click(); n.focus();
    });
  }

  /* ---------- Copy buttons ---------- */
  $$('[data-ah-copy]').forEach((b) => b.addEventListener('click', () => {
    const el = document.getElementById(b.dataset.ahCopy);
    const was = b.textContent; navigator.clipboard?.writeText(el.textContent.trim()).then(() => { b.textContent = 'Copied'; b.classList.add('is-done'); setTimeout(() => { b.textContent = was; b.classList.remove('is-done'); }, 1600); }).catch(() => {});
  }));

  /* ---------- Product page ---------- */
  const pj = $('#ah-product-json');
  if (pj) {
    const product = JSON.parse(pj.textContent);
    const form = $('[data-ah-product-form]');
    const idInput = $('[data-ah-variant-id]', form);
    const sets = $$('[data-ah-option]', form);
    let qty = 1;
    const selected = () => sets.map((s) => $('[aria-checked="true"]', s)?.dataset.value);
    const findVariant = (sel) => product.variants.find((v) => v.options.every((o, i) => o === sel[i]));
    const update = () => {
      const v = sets.length ? findVariant(selected()) : product.variants[0];
      const submit = $('[data-ah-submit]', form);
      sets.forEach((s, i) => {
        const lab = $('[data-ah-option-label]', s); if (lab) lab.textContent = selected()[i] || '';
        $$('[data-value]', s).forEach((b) => {
          const trial = selected(); trial[i] = b.dataset.value;
          const tv = findVariant(trial); b.classList.toggle('is-na', !tv || !tv.available);
        });
      });
      const barBtn = $('[data-ah-bar-add]');
      if (!v) { submit.disabled = true; submit.textContent = 'Unavailable'; if (barBtn) { barBtn.disabled = true; barBtn.textContent = 'Unavailable'; } return; }
      idInput.value = v.id;
      submit.disabled = !v.available; submit.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (barBtn) { barBtn.disabled = !v.available; barBtn.textContent = submit.textContent; }
      const price = $('[data-ah-price]');
      price.innerHTML = fmt(v.price) + (v.compare_at_price > v.price ? `<s>${fmt(v.compare_at_price)}</s>` : '');
      const save = $('[data-ah-save]'); save.hidden = !(v.compare_at_price > v.price); if (!save.hidden) save.textContent = 'Save ' + fmt(v.compare_at_price - v.price);
      const bp = $('[data-ah-price-bar]'); if (bp) bp.textContent = fmt(v.price);
      const sku = $('[data-ah-sku]'); if (sku && v.sku) sku.textContent = v.sku;
      if (v.featured_media) {
        const fig = $(`#ah-gallery [data-media-id="${v.featured_media.id}"]`), g = $('#ah-gallery');
        if (fig && g.firstElementChild !== fig) {
          const img = $('img', g.firstElementChild);
          // Bring the variant's photo to the lead slot with a short crossfade, then make sure it is in view.
          img.classList.add('is-swap');
          setTimeout(() => {
            g.prepend(fig); img.classList.remove('is-swap');
            if (g.scrollWidth > g.clientWidth + 4) g.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' });
            const top = g.getBoundingClientRect().top;
            if (!small.matches && top < 0) scrollTo({ top: scrollY + top - 90, behavior: reduce ? 'auto' : 'smooth' });
          }, 200);
        }
        const bi = $('[data-ah-bar-img]'), src = v.featured_media.preview_image?.src;
        if (bi && src) { bi.removeAttribute('srcset'); bi.src = src + (src.includes('?') ? '&' : '?') + 'width=160'; }
      }
      // A colour with no photo of its own says so on the lead photo, instead of passing off another colour.
      const ci = sets.findIndex((s) => s.hasAttribute('data-colour'));
      const noPhoto = ci > -1 && !v.featured_media && product.variants.some((x) => x.featured_media);
      $('.ah-gnote')?.remove();
      if (noPhoto) {
        const note = document.createElement('p'); note.className = 'ah-gnote';
        note.textContent = `No photo of ${selected()[ci]} yet. Message us and we will send one.`;
        setTimeout(() => $('#ah-gallery')?.firstElementChild?.append(note), 230);
      }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
      document.dispatchEvent(new CustomEvent('ah:variant', { detail: v }));
    };
    sets.forEach((s) => {
      $$('[data-value]', s).forEach((b) => b.addEventListener('click', () => { $$('[data-value]', s).forEach((x) => x.setAttribute('aria-checked', x === b)); update(); }));
      $('[role="radiogroup"]', s).addEventListener('keydown', (e) => {
        if (!['ArrowRight', 'ArrowLeft'].includes(e.key)) return;
        const all = $$('[data-value]', s), i = all.findIndex((x) => x.getAttribute('aria-checked') === 'true');
        const n = all[(i + (e.key === 'ArrowRight' ? 1 : all.length - 1)) % all.length]; n.click(); n.focus();
      });
    });
    $$('[data-ah-qty]', form).forEach((b) => b.addEventListener('click', () => {
      qty = Math.max(1, Math.min(20, qty + +b.dataset.ahQty)); $('[data-ah-qty-val]', form).textContent = qty; $('[data-ah-qty-input]', form).value = qty;
    }));
    const submitAdd = (btn) => ahAdd([{ id: +idInput.value, quantity: qty }], btn).catch((err) => { const e = $('[data-ah-error]', form); e.hidden = false; e.textContent = err.message; });
    form.addEventListener('submit', (e) => { e.preventDefault(); submitAdd($('[data-ah-submit]', form)); });
    $('[data-ah-bar-add]')?.addEventListener('click', (e) => submitAdd(e.currentTarget));
    if (sets.length) update();

    const mf = $('#ah-minifit');
    if (mf) {
      const W = +mf.dataset.w, inp = $('#ah-mf-w');
      const draw = () => {
        const wall = Math.max(60, Math.min(800, +inp.value || 0)), spare = wall - W, side = Math.round(spare / 2);
        mf.style.setProperty('--sw', Math.min(100, (W / wall) * 100) + '%');
        mf.classList.toggle('is-tight', spare >= 0 && spare < 20);
        mf.classList.toggle('is-over', spare < 0);
        $('[data-mf-l]', mf).textContent = $('[data-mf-r]', mf).textContent = spare > 0 ? side + ' cm' : '';
        $('[data-mf-wall]', mf).textContent = wall + ' cm';
        $('#ah-mf-v').innerHTML = spare >= 20 ? `<b>Fits.</b> ${side} cm free on each side.` : spare >= 0 ? `<b>Just fits.</b> Leave 20 cm in total to walk past comfortably.` : `<b>${-spare} cm too wide.</b> Ask us about a custom size.`;
      };
      inp.addEventListener('input', draw);
      $$('[data-mf]', mf).forEach((b) => b.addEventListener('click', () => { inp.value = Math.max(60, Math.min(800, (+inp.value || 0) + +b.dataset.mf)); draw(); }));
      draw();
    }
    // Phones: the buy bar shows whenever the main Add to cart button is off screen, above or below,
    // so the button is reachable from the first screen.
    const bb = $('#ah-buybar'), sb = $('[data-ah-submit]');
    if (bb && sb) new IntersectionObserver(([e]) => { const off = e.intersectionRatio < 0.95; bb.classList.toggle('is-on', off); document.body.classList.toggle('ah-has-bar', off && small.matches); }, { threshold: [0, 0.95, 1] }).observe(sb);

    /* Reviews wall buttons hand over to Judge.me's own (hidden) widget: its review form and its
       pop-up of all this piece's reviews. The form closes on Esc or a click outside the sheet. */
    const jmForm = () => { const f = $('#judgeme_product_reviews .jdgm-form-wrapper'); return f && getComputedStyle(f).display !== 'none' ? f : null; };
    // Judge.me binds its buttons on the visitor's first interaction, so a first click can land before
    // they are ready. Click, then check that the form or pop-up actually opened, and try again if not.
    const jmOpen = (sel, isOpen, btn, tries = 0) => {
      if (isOpen()) { btn?.classList.remove('is-loading'); return; }
      $('#judgeme_product_reviews ' + sel)?.click();
      if (tries < 8) setTimeout(() => jmOpen(sel, isOpen, btn, tries + 1), 650); else btn?.classList.remove('is-loading');
    };
    // Once the form is open, give the sheet a close button in its corner (it clicks Judge.me's Cancel).
    const dressForm = () => {
      const f = jmForm(), form = f && $('.jdgm-form', f);
      if (form && !$('.ah-form-x', form)) {
        const x = document.createElement('button'); x.type = 'button'; x.className = 'ah-form-x'; x.setAttribute('aria-label', 'Close the review form');
        x.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
        x.addEventListener('click', () => $('.jdgm-cancel-rev', f)?.click());
        form.prepend(x);
      }
      return !!f;
    };
    $('[data-jm-write]')?.addEventListener('click', (e) => { e.currentTarget.classList.add('is-loading'); jmOpen('.jdgm-write-rev-link', dressForm, e.currentTarget); });
    $('[data-jm-all]')?.addEventListener('click', (e) => { e.currentTarget.classList.add('is-loading'); jmOpen('.jdgm-row-readmore .jdgm-btn', () => !!$('.jm-mfp-wrap'), e.currentTarget); });
    document.addEventListener('mousedown', (e) => { if (e.target.classList && e.target.classList.contains('jdgm-form-wrapper')) $('.jdgm-cancel-rev', e.target)?.click(); });
    addEventListener('keydown', (e) => { if (e.key === 'Escape') { const f = jmForm(); if (f) $('.jdgm-cancel-rev', f)?.click(); } });

    /* Zoom viewer: every gallery photo opens full screen; tap or click zooms in, drag or scroll to pan. */
    const gal = $('#ah-gallery');
    if (gal) {
      let lb = null, back = null;
      const big = (img) => { const u = img.currentSrc || img.src; return u.replace(/([?&])width=\d+/, '$1width=2400'); };
      const closeLb = () => { if (!lb) return; const el = lb; lb = null; el.classList.remove('is-open'); document.documentElement.classList.remove('ah-lock'); setTimeout(() => el.remove(), 260); removeEventListener('keydown', onKey); back?.focus(); };
      const go = (d) => { const t = $('.ah-lb__track', lb); t.scrollBy({ left: d * t.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); };
      const onKey = (e) => { if (!lb) return; if (e.key === 'Escape') closeLb(); if (e.key === 'ArrowRight') go(1); if (e.key === 'ArrowLeft') go(-1); };
      const openLb = (i) => {
        back = document.activeElement;
        const imgs = $$('figure img', gal);
        lb = document.createElement('div');
        lb.className = 'ah ah-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', `${product.title} photos`);
        lb.innerHTML = `<div class="ah-lb__bar"><span data-lb-n>${i + 1} / ${imgs.length}</span><button class="ah-lb__x" type="button" aria-label="Close photos"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>
          <div class="ah-lb__track">${imgs.map((im) => `<div class="ah-lb__slide"><img src="${big(im)}" alt="${(im.alt || '').replace(/"/g, '&quot;')}" draggable="false"></div>`).join('')}</div>
          <div class="ah-lb__foot"><div class="ah-lb__nav"><button type="button" data-lb="-1" aria-label="Previous photo"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button></div><div class="ah-lb__dots">${imgs.map(() => '<i></i>').join('')}</div><span class="ah-lb__hint">Tap the photo to zoom</span><div class="ah-lb__nav"><button type="button" data-lb="1" aria-label="Next photo"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button></div></div>`;
        document.body.append(lb); document.documentElement.classList.add('ah-lock');
        const track = $('.ah-lb__track', lb), dots = $$('.ah-lb__dots i', lb);
        const mark = () => { const n = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); dots.forEach((d, k) => d.classList.toggle('is-on', k === n)); $('[data-lb-n]', lb).textContent = `${n + 1} / ${imgs.length}`; $$('.ah-lb__slide.is-zoom', lb).forEach((s) => s !== track.children[n] && s.classList.remove('is-zoom')); };
        track.addEventListener('scroll', () => requestAnimationFrame(mark), { passive: true });
        requestAnimationFrame(() => { track.scrollLeft = i * track.clientWidth; mark(); lb.classList.add('is-open'); $('.ah-lb__x', lb).focus(); });
        $('.ah-lb__x', lb).addEventListener('click', closeLb);
        $$('[data-lb]', lb).forEach((b) => b.addEventListener('click', () => go(+b.dataset.lb)));
        $$('.ah-lb__slide', lb).forEach((slide) => slide.addEventListener('click', (e) => {
          const img = $('img', slide); if (e.target !== img) return;
          const r = img.getBoundingClientRect(), fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
          const on = slide.classList.toggle('is-zoom');
          track.style.overflowX = on ? 'hidden' : '';
          if (on) requestAnimationFrame(() => { slide.scrollLeft = fx * img.offsetWidth - slide.clientWidth / 2; slide.scrollTop = fy * img.offsetHeight - slide.clientHeight / 2; });
        }));
        addEventListener('keydown', onKey);
      };
      gal.addEventListener('click', (e) => {
        const fig = e.target.closest('figure'); if (!fig || (gal.classList.contains('is-drag'))) return;
        openLb($$('figure', gal).indexOf(fig));
      });
    }
  }
})();
